export default "__VITE_ASSET__dRnnw1gE__"